import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined'
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutlined'
import DevicesOtherOutlinedIcon from '@mui/icons-material/DevicesOtherOutlined'
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined'
import CardMembershipIcon from '@mui/icons-material/CardMembership'
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined'
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined'
import DeveloperBoardOutlinedIcon from '@mui/icons-material/DeveloperBoardOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined'
import HistoryIcon from '@mui/icons-material/History'
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

const menuItems = [
  { path: '/', labelKey: 'toMain', icon: <SpaceDashboardOutlinedIcon /> },
  {
    path: '/users',
    labelKey: 'users',
    icon: <PeopleOutlineIcon />,
    permission: ['page.users', 'page.roles', 'page.permissions'],
    adminByTitle: 'administrator'
  },
  {
    path: '/devices',
    labelKey: 'devices',
    icon: <DevicesOtherOutlinedIcon />,
    permission: 'page.devices'
  },
  {
    path: '/partners',
    labelKey: 'partners',
    icon: <BusinessCenterOutlinedIcon />,
    permission: 'page.partners'
  },
  {
    path: '/additional',
    labelKey: 'additional',
    icon: <AddCircleOutlineOutlinedIcon />,
    permission: 'page.additional'
  },
  {
    path: '/abonements',
    labelKey: 'abonements',
    icon: <CardMembershipIcon />
    // permission: 'page.abonements'
  },
  {
    path: '/entries-history',
    labelKey: 'entries_history',
    icon: <HistoryIcon />,
    permission: 'page.entries_history'
  },
  {
    path: '/reports',
    labelKey: 'reports',
    icon: <BarChartOutlinedIcon />,
    permission: 'report.visible',
    children: [
      {
        path: '/reports/transactions',
        labelKey: 'report_transactions',
        permission: 'report.visible'
      },
      {
        path: '/reports/recognitions',
        labelKey: 'report_recognitions',
        permission: 'report.visible'
      },
      {
        path: '/reports/entries-exits',
        labelKey: 'report_entries_exits',
        permission: 'report.visible'
      },
      {
        path: '/reports/dwell-time',
        labelKey: 'report_dwell_time',
        permission: 'report.visible'
      },
      {
        path: '/reports/dashboard',
        labelKey: 'report_dashboard',
        permission: 'report.visible'
      },
      {
        path: '/reports/analytics',
        labelKey: 'report_analytics_charts',
        permission: 'report.visible'
      }
    ]
  },
  {
    path: '/employees',
    labelKey: 'employees',
    icon: <BadgeOutlinedIcon />,
    adminByTitle: 'employees_viewer'
  },
  {
    path: '/oranges',
    labelKey: 'oranges',
    icon: <DnsOutlinedIcon />,
    adminByTitle: 'administrator'
  },
  {
    path: '/device-panel',
    labelKey: 'device_panel',
    icon: <DeveloperBoardOutlinedIcon />,
    adminByTitle: 'administrator'
  },
  {
    path: '/system-settings',
    labelKey: 'system_settings',
    icon: <SettingsOutlinedIcon />,
    adminByTitle: 'administrator'
  }
]

export default menuItems
